import React, { useEffect, useState } from "react";
import PATH from "../../../../urls/path";
import { ReactComponent as Contact } from "../../../../assets/images/sidebar/contact.svg";
import { ReactComponent as Folder } from "../../../../assets/images/sidebar/Folder.svg";
import { ReactComponent as Favorite } from "../../../../assets/images/sidebar/Favorite.svg";
import { ReactComponent as Trash } from "../../../../assets/images/sidebar/Trash.svg";
import { ReactComponent as Shared } from "../../../../assets/images/sidebar/Shared.svg";
import { ReactComponent as Dashboard } from "../../../../assets/images/sidebar/Dashboard.svg";
import { ReactComponent as Chart } from "../../../../assets/images/sidebar/Chart.svg";
import { ReactComponent as Plan } from "../../../../assets/images/sidebar/clipboard-text.svg";
import { ReactComponent as Setting } from "../../../../assets/images/sidebar/setting-sidebar.svg";
import { ReactComponent as Feedback } from "../../../../assets/images/svg/feedback.svg";
import { ReactComponent as Rules } from "../../../../assets/images/sidebar/task-square.svg";
import { ReactComponent as Info } from "../../../../assets/images/sidebar/info.svg";
import { Link, useLocation } from "react-router-dom";
import { getFileManagerParent, getRootPublicLinkFolder, getWebEnvConfig, isTouchScreen } from "../../../../scripts/helpers";

export default function SidebarMenuItems(): JSX.Element {
    const driveMenuItems = [
        {
            title: "میز کار",
            path: PATH.dashboard,
            icon: <Dashboard className="fill-secondary-600 transition" />
        },
        {
            title: "فایل‌های من",
            path: PATH.files,
            icon: <Folder className="fill-secondary-600 transition" />
        },
        {
            title: "فایل‌های اشتراکی",
            path: PATH.shared,
            icon: <Shared className="fill-secondary-600 transition" />
        },
        {
            title: "وضعیت فضای ابری",
            path: PATH.plan,
            icon: <Plan className="fill-secondary-600 transition" />
        },
        {
            title: "لیست مخاطبین",
            path: PATH.contact,
            icon: <Contact className="fill-secondary-600 transition" />
        },
        {
            title: "علاقه‌مندی‌ها",
            path: PATH.favorite,
            icon: <Favorite className="fill-secondary-600 transition" />
        },
        {
            title: "سطل زباله",
            path: PATH.trash,
            icon: <Trash className="fill-secondary-600 transition" />
        },
        {
            title: "گزارش‌گیری",
            path: PATH.report,
            icon: <Chart className="fill-secondary-600 transition" />
        },
        {
            title: "تنظیمات",
            path: PATH.settings,
            icon: <Setting className="fill-secondary-600 transition" />
        },
        {
            title: "ثبت بازخورد",
            path: PATH.feedback,
            icon: <Feedback className="fill-secondary-600 transition" />
        }
    ];

    const [currentRoute, setCurrentRoute] = useState<string>("");
    const currLocation = useLocation();

    useEffect(() => {
        let res = currLocation.pathname;
        if (res === PATH.dashboard) res = PATH.dashboard;
        setCurrentRoute(res);
    }, [currLocation]);

    return (
        <React.Fragment>
            {!isTouchScreen() ? (
                <>
                    {window.innerWidth >= 1024 ? (
                        <div className="sm:hidden lg:block" id="sidebar-menu-items">
                            {driveMenuItems.map((item, index) => (
                                <Link
                                    key={index}
                                    to={item.path}
                                    className={`${item.path === currentRoute && !(getRootPublicLinkFolder() && getRootPublicLinkFolder() === getFileManagerParent()) ? "active" : ""} ${item.path === PATH.feedback && "lg:hidden"} flex items-center gap-4 h-[50px] mb-2 group transition border-r-4 border-transparent`}
                                >
                                    <div
                                        id={item.path === PATH.contact ? "contact-sidebar" : item.path === PATH.report ? "report" : ""}
                                        className={`${item.path === PATH.contact && "contact-sidebar"} ${item.path === PATH.report && "report"} group-hover:bg-secondary-200 w-full h-full mx-4 px-3 rounded-[10px] flex items-center gap-4 transition`}
                                    >
                                        {item.title === "فایل‌های اشتراکی" &&
                                        getRootPublicLinkFolder() &&
                                        getRootPublicLinkFolder() === getFileManagerParent() ? (
                                            <Shared className="!fill-secondary-600" />
                                        ) : (
                                            item.icon
                                        )}
                                        <span
                                            className={`${getRootPublicLinkFolder() && getRootPublicLinkFolder() === getFileManagerParent() ? "!text-secondary-600 text-[15px]" : "text-secondary-600 text-[15px] transition"}`}
                                        >
                                            {item.title}
                                        </span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    ) : (
                        <div className="overflow-auto hidden sm:block lg:hidden" id="sidebar-menu-items">
                            {driveMenuItems.map((item) => {
                                return (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        className={`${item.path === currentRoute && !(getRootPublicLinkFolder() && getRootPublicLinkFolder() === getFileManagerParent()) ? "active" : ""} flex items-center justify-center h-[50px] mb-2 group transition !border-none`}
                                    >
                                        <div
                                            id={item.path === PATH.contact ? "contact-sidebar" : item.path === PATH.report ? "report" : ""}
                                            className={`${item.path === currentRoute && !(getRootPublicLinkFolder() && getRootPublicLinkFolder() === getFileManagerParent()) ? "bg-primary-50" : "group-hover:bg-secondary-200"} w-full h-full mx-4 px-3 rounded-[10px] flex items-center transition`}
                                        >
                                            {item.title === "فایل‌های اشتراکی" &&
                                            getRootPublicLinkFolder() &&
                                            getRootPublicLinkFolder() === getFileManagerParent() ? (
                                                <Shared className="!fill-secondary-600" />
                                            ) : (
                                                <span
                                                    className={`${item.path === PATH.contact && "contact-sidebar"} ${item.path === PATH.report && "report"}`}
                                                >
                                                    {item.icon}
                                                </span>
                                            )}
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    )}
                </>
            ) : (
                <div id="sidebar-menu-items">
                    {driveMenuItems.map((item, index) => (
                        <Link
                            key={index}
                            to={item.path}
                            className={`${item.path === currentRoute && !(getRootPublicLinkFolder() && getRootPublicLinkFolder() === getFileManagerParent()) ? "active" : ""} flex items-center gap-4 h-[50px] mb-2 group transition border-r-4 border-transparent`}
                        >
                            <div
                                className={`${item.path === PATH.contact && "contact-sidebar"} ${item.path === PATH.report && "report"} group-hover:bg-secondary-200 w-full h-full mx-4 px-3 rounded-[10px] flex items-center gap-4 transition`}
                            >
                                {item.title === "فایل‌های اشتراکی" &&
                                getRootPublicLinkFolder() &&
                                getRootPublicLinkFolder() === getFileManagerParent() ? (
                                    <Shared className="!fill-secondary-600" />
                                ) : (
                                    item.icon
                                )}
                                <span
                                    className={`${getRootPublicLinkFolder() && getRootPublicLinkFolder() === getFileManagerParent() ? "!text-secondary-600 text-[15px]" : "text-secondary-600 text-[15px] transition"}`}
                                >
                                    {item.title}
                                </span>
                            </div>
                        </Link>
                    ))}
                    <a
                        target="_blank"
                        href={`${getWebEnvConfig("landingBaseUrl")}rules`}
                        className={`flex items-center gap-4 h-[50px] mb-2 group transition border-r-4 border-transparent`}
                        rel="noreferrer"
                    >
                        <div className={`group-hover:bg-secondary-200 w-full h-full mx-4 px-3 rounded-[10px] flex items-center gap-4 transition`}>
                            <Rules />
                            <span className="text-secondary-600 text-[15px] transition">قوانین</span>
                        </div>
                    </a>
                    <a
                        target="_blank"
                        href={`${getWebEnvConfig("landingBaseUrl")}help`}
                        className={`flex items-center gap-4 h-[50px] mb-2 group transition border-r-4 border-transparent`}
                        rel="noreferrer"
                    >
                        <div className={`group-hover:bg-secondary-200 w-full h-full mx-4 px-3 rounded-[10px] flex items-center gap-4 transition`}>
                            <Info />
                            <span className="text-secondary-600 text-[15px] transition">راهنمای استفاده از ابرهمراهی</span>
                        </div>
                    </a>
                </div>
            )}
        </React.Fragment>
    );
}
